import { createStore } from './storeFactory';
import CaptainToolsAPI from '../../api/captain/tools';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const toolsStore = createStore({
  name: 'captainTool',
  API: CaptainToolsAPI,
  actions: mutations => ({
    getTools: async ({ commit }, { assistantId } = {}) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const params = assistantId ? { assistant_id: assistantId } : {};
        const response = await CaptainToolsAPI.get(params);
        commit(mutations.SET, response.data.payload || response.data);
        if (response.data.meta) {
          commit(mutations.SET_META, response.data.meta);
        }
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
        return throwErrorMessage(error);
      }
    },
  }),
});

export default toolsStore;
